<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { paymentOptions } from '../composables/salesPropertyFormOptions';
import SalesDetailFactList from './SalesDetailFactList.vue';

const props = defineProps({ transaction: { type: Object, required: true } });
const { t } = useI18n();
const profile = computed(() => props.transaction.profile || {});
const paymentMethodLabel = value =>
  paymentOptions(t).find(option => option.value === String(value))?.label ||
  value;
const paymentMethods = computed(() => {
  const values = Array.isArray(profile.value.forma_pagamento)
    ? profile.value.forma_pagamento
    : String(profile.value.forma_pagamento || '')
        .split(',')
        .filter(Boolean);
  return values.map(paymentMethodLabel).join(', ');
});
const manager = computed(
  () => props.transaction.manager_details || props.transaction.manager || {}
);
const items = computed(() => [
  {
    key: 'payment-method',
    label: t('SALES.DETAIL.SALE_SUMMARY.PAYMENT_METHOD'),
    value: paymentMethods.value,
  },
  {
    key: 'commission-net',
    label: t('SALES.DETAIL.SALE_SUMMARY.COMMISSION_VALUE'),
    value: profile.value.valor_comissao_liquida,
  },
  {
    key: 'manager',
    label: t('SALES.DETAIL.MANAGER'),
    value: manager.value.display_name || manager.value.name,
  },
  {
    key: 'branch',
    label: t('SALES.DETAIL.SALE_SUMMARY.STORE'),
    value: manager.value.branch_name,
  },
]);
</script>

<template>
  <LaisCard
    :title="t('SALES.DETAIL.SALE_SUMMARY.COMMISSION_TITLE')"
    prefix-icon="i-lucide-circle-dollar-sign"
  >
    <SalesDetailFactList :items="items" />
  </LaisCard>
</template>
